import { Injectable, ComponentRef, Provider } from '@angular/core';
import { IAgeConfirmDialogService, IAgeConfirmDialogServiceToken } from 'projects/shared/lib/interfaces/services/dialogs/age-confirm-dialog-service-abstract';
import { DialogBaseService } from 'projects/shared/lib/services/ui/dialog.service';
import { AgeConfirmDialogComponent } from '../../components/shared/dialog/age-confirm-dialog/age-confirm-dialog.component';

@Injectable({
  providedIn: 'root',
}) export class AgeConfirmDialogService implements IAgeConfirmDialogService
{
  ageConfirmDialogShow(
    callbackCancel: () => void,
    callbackYes?: () => void,
    callbackNo?: () => void,
  )
  {
    DialogBaseService.dialogGenericShow(
      AgeConfirmDialogComponent,
      (component: ComponentRef<AgeConfirmDialogComponent>) =>
      {
        component.instance.modalCancel.subscribe(
          () =>
          {
            callbackCancel();
            DialogBaseService.dynamicComponentRemove(component);
          }
        );

        component.instance.modalYes.subscribe(
          () =>
          {
            callbackYes?.();
            DialogBaseService.dynamicComponentRemove(component);
          }
        );
        component.instance.modalNo.subscribe(
          () =>
          {
            callbackNo?.();
            DialogBaseService.dynamicComponentRemove(component);
          }
        );
      }
    );
  }

}
/**
 * Prepared provider with the token to implementation mapping.
 * Reference this at the desired provider list to enable the injection of this implementation by referencing the token(interface).
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const AgeConfirmDialogServiceProvider: Provider[] = [
  { provide: IAgeConfirmDialogServiceToken, useExisting: AgeConfirmDialogService }
];


